const ChecklistAnswersCard = ({ checklist }) => {
  const hasChecklist = Array.isArray(checklist) && checklist.length > 0;

  const HEADERS = ["#", "Checklist item", "Answer"];

  return (
    <section>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl font-bold text-gray-900">Checklist answers by vendor</h2>
      </div>

      {!hasChecklist ? (
        <div className="bg-white border border-gray-100 shadow-sm rounded-lg p-5 text-sm text-gray-500">
          No checklist questions provided
        </div>
      ) : (
        <div className="w-full bg-white shadow rounded-lg overflow-hidden">
          <div className="max-h-[300px] overflow-y-auto overflow-x-auto">
            <table className="w-full table-auto border-collapse">
              <thead className="sticky top-0 z-10">
                <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
                  {HEADERS.map((h) => (
                    <th key={h} className="px-3 py-2 text-center font-semibold whitespace-nowrap">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {checklist.map((item, i) => {
                  const rowBg = i % 2 === 0 ? "bg-gray-50" : "bg-white";
                  return (
                    <tr key={item.id || i} className={`${rowBg} hover:bg-brand-50 transition-colors`}>
                      <td className="px-3 py-2 text-xs text-center whitespace-nowrap text-gray-500">
                        {i + 1}
                      </td>
                      <td className="px-3 py-2 text-xs break-words text-gray-900">
                        {item.question || "—"}
                      </td>
                      <td className="px-3 py-2 text-xs text-center">
                        {item.answer ? (
                          <span className="text-emerald-700 font-medium">{item.answer}</span>
                        ) : (
                          "—"
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  );
};

export default ChecklistAnswersCard;
